const DigitalFiles = {
    newsletterPdfOnly: 5,
    newsletterPdfProof: 6,
};

export default DigitalFiles;
